module.exports = __webpack_public_path__ + "img/PL08447.ce125c71.png";